import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

const TabButton = forwardRef(({ label, children, ...props }, ref) => (
  <Button
    {...props}
    ref={ref}
    sx={{
      flex: 1,
      alignItems: 'center',
      height: '36px',
      boxShadow: 'none',
    }}
  >
    {label}
    {children}
  </Button>
));

TabButton.propTypes = {
  Icon: PropTypes.elementType,
  label: PropTypes.string,
  iconProps: PropTypes.object,
  children: PropTypes.any,
};

export default TabButton;
